import {
	apiClient,
	getAuthHeaders,
	handleServiceError,
} from 'api/config/config';

// Link Services
export const linkService = {
	// --- CRUD --- //
	getAll: async (token) => {
		try {
			return await apiClient.post(
				'client/api/v1/link/list',
				{
					options: {
						paginate: 100,
						sort: { createdAt: -1 },
						include: [
							{
								model: 'Brand',
								attributes: ['brandName', 'image'],
								as: '_brandId',
							},
						],
						where: { type: 'client' },
					},
					isCountOnly: false,
				},
				getAuthHeaders(token)
			);
		} catch (error) {
			handleServiceError(error);
		}
	},
	add: async (token, link) => {
		try {
			return await apiClient.post(
				'client/api/v1/link/create',
				{
					bumbeiId: link.bumbeiId,
					shortLink: link.shortLink,
					shortIoId: link.shortIoId,
					link: link.link,
					advertiserId: link.advertiserId,
					networkId: link.networkId,
					brandId: link.brandId,
					brandName: link.brandName,
					domain: link.domain,
					status: link.status,
					campaign: link.campaign,
					type: link.type,
					tracker: link.tracker,
					sendLink: link.sendLink,
				},
				getAuthHeaders(token)
			);
		} catch (error) {
			handleServiceError(error);
		}
	},
	getShort: async (token, originalURL) => {
		try {
			return await apiClient.post(
				'client/api/v1/link/getShortLink',
				{
					link: originalURL,
				},
				getAuthHeaders(token)
			);
		} catch (error) {
			handleServiceError(error);
		}
	},
};
